// eslint-disable-next-line import/prefer-default-export
export function isSchemeParams(scheme) {
  return Object.prototype.toString.call(scheme) !== '[object String]';
}